import { render, staticRenderFns } from "./VendorExportDetails.vue?vue&type=template&id=4d9d3ac8&"
import script from "./VendorExportDetails.vue?vue&type=script&lang=js&"
export * from "./VendorExportDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports